import { TableHeaderProps } from '../types';

export const tableHeaderCell: TableHeaderProps[] = [
  { cellName: 'Loja' },
  { cellName: 'Operador' },
  { cellName: 'Caixa' },
  { cellName: 'Status' },
  { cellName: 'Saldo' },
];
